import moment from "moment";

export const getPlaningDaysDiff = (date) => {
  const planingDate = moment(moment(date).format("YYYY-MM-DD"))
  const currentDate = moment(moment().format("YYYY-MM-DD"))
  const differenceInDays = planingDate.diff(currentDate, 'days') + 1;
  return differenceInDays
}